/* src/app/shared/components/flow-badge/flow-badge.component.scss */
.flow-badge {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
}
.flow-badge .icon {
  height: 12px;
  width: 12px;
}
.flow-badge .status {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.flow-badge .status.color-neutral {
  background-color: #a1a1aa;
}
.flow-badge .status.color-yellow {
  background-color: #facc15;
}
.flow-badge .status.color-orange {
  background-color: #fb923c;
}
.flow-badge .status.color-red {
  background-color: #dc2626;
}
.flow-badge .status.color-green {
  background-color: #16a34a;
}
.flow-badge .status.color-blue {
  background-color: #4568d0;
}
.flow-badge .status.color-purple {
  background-color: #7e22ce;
}
.flow-badge .divider {
  width: 1px;
  height: 40px;
}
.flow-badge.size-micro {
  height: 20px;
  gap: 4px;
  border-radius: 6px;
  padding: 4px 6px;
}
.flow-badge.size-medium {
  height: 28px;
  gap: 8px;
  border-radius: 8px;
  padding: 6px 8px;
}
.flow-badge.size-large {
  height: 36px;
  gap: 8px;
  border-radius: 12px;
  padding: 8px 14px;
}
.flow-badge.size-large .status {
  width: 8px;
  height: 8px;
}
.flow-badge.color-neutral {
  background-color: #f4f4f5;
  border-radius: 1px solid #e4e4e7;
}
.flow-badge.color-neutral .h5-semibold {
  color: #27272a;
}
.flow-badge.color-neutral .divider {
  background-color: #e4e4e7;
}
.flow-badge.color-neutral .icon {
  filter: brightness(0) saturate(100%) invert(36%);
}
.flow-badge.color-yellow {
  background-color: #fef9c3;
  border-radius: 1px solid #fef08a;
}
.flow-badge.color-yellow .h5-semibold {
  color: #854d0e;
}
.flow-badge.color-yellow .divider {
  background-color: #fef08a;
}
.flow-badge.color-yellow .icon {
  filter: brightness(0) saturate(100%) invert(29%) sepia(88%) saturate(453%) hue-rotate(351deg) brightness(94%) contrast(99%);
}
.flow-badge.color-orange {
  background-color: #ffedd5;
  border-radius: 1px solid #fed7aa;
}
.flow-badge.color-orange .h5-semibold {
  color: #9a3412;
}
.flow-badge.color-orange .divider {
  background-color: #fed7aa;
}
.flow-badge.color-orange .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(42%) saturate(2304%) hue-rotate(348deg) brightness(86%) contrast(99%);
}
.flow-badge.color-red {
  background-color: #fee2e2;
  border-radius: 1px solid #fecaca;
}
.flow-badge.color-red .h5-semibold {
  color: #991b1b;
}
.flow-badge.color-red .divider {
  background-color: #fecaca;
}
.flow-badge.color-red .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(31%) saturate(6219%) hue-rotate(345deg) brightness(89%) contrast(99%);
}
.flow-badge.color-green {
  background-color: #dcfce7;
  border-radius: 1px solid #bbf7d0;
}
.flow-badge.color-green .h5-semibold {
  color: #166534;
}
.flow-badge.color-green .divider {
  background-color: #bbf7d0;
}
.flow-badge.color-green .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(47%) saturate(719%) hue-rotate(90deg) brightness(100%) contrast(91%);
}
.flow-badge.color-blue {
  background-color: #e0e9f9;
  border-radius: 1px solid #c8d9f5;
}
.flow-badge.color-blue .h5-semibold {
  color: #33459a;
}
.flow-badge.color-blue .divider {
  background-color: #c8d9f5;
}
.flow-badge.color-blue .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(81%) saturate(2106%) hue-rotate(218deg) brightness(106%) contrast(101%);
}
.flow-badge.color-purple {
  background-color: #f3e8ff;
  border-radius: 1px solid #e9d5ff;
}
.flow-badge.color-purple .h5-semibold {
  color: #6b21a8;
}
.flow-badge.color-purple .divider {
  background-color: #e9d5ff;
}
.flow-badge.color-purple .icon {
  filter: brightness(0) saturate(100%) invert(14%) sepia(64%) saturate(4151%) hue-rotate(267deg) brightness(100%) contrast(96%);
}
/*# sourceMappingURL=flow-badge.component.css.map */
